import React from "react";
import "../../../styles/pages/homePage/docReqQuickLink.scss";
import { Card, Button, Tag, Typography, Empty, Tooltip } from "antd";

import { ArrowRightOutlined } from "@ant-design/icons";

const DocReqQuickLink = ({
  cardTitle = "Quick Link",
  children,
  onQuickLink,
}) => {
  return (
    <div className="docreq-quicklink">
      <Card
        className="ql-card"
        title={cardTitle}
        extra={
          <Tooltip title="Quick Link">
            <Button
              type="primary"
              // shape="circle"
              icon={<ArrowRightOutlined />}
              iconPosition="end"
              onClick={onQuickLink}
            >
              View More
            </Button>
          </Tooltip>
        }
      >
        {children}
      </Card>
    </div>
  );
};

export default DocReqQuickLink;
